import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=e1364d54&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=e1364d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1364d54",
  null
  
)

export default component.exports